import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../common/constants/proptypes/CommonPropTypes";
import { SEARCH } from "../../../constants/perspectives";
import AddonDiscoveryPropTypes from "../../../constants/proptypes/AddonDiscoveryPropTypes";
import FiltersLink from "./FiltersLink";

var SearchFiltersLink = /*#__PURE__*/function (_Component) {
  _inherits(SearchFiltersLink, _Component);

  var _super = _createSuper(SearchFiltersLink);

  function SearchFiltersLink() {
    _classCallCheck(this, SearchFiltersLink);

    return _super.apply(this, arguments);
  }

  _createClass(SearchFiltersLink, [{
    key: "render",
    value: function render() {
      var href = this.props.filtersContext.get('searchFacetHrefResolver') ? this.props.filtersContext.get('searchFacetHrefResolver')({
        filters: this.props.newFilters
      }) : '#';
      return /*#__PURE__*/React.createElement(FiltersLink, {
        className: this.props.className,
        href: href,
        newFilters: this.props.newFilters,
        newPerspective: SEARCH,
        onClick: this.props.onClick
      }, this.props.children);
    }
  }]);

  return SearchFiltersLink;
}(Component);

_defineProperty(SearchFiltersLink, "propTypes", {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  filtersContext: AddonDiscoveryPropTypes.filtersContext.isRequired,
  newFilters: CommonPropTypes.filters.isRequired,
  onClick: PropTypes.func
});

export { SearchFiltersLink as default };